// extracted by mini-css-extract-plugin
module.exports = {"container":"SettlementRequirement_container__29zaV","icon":"SettlementRequirement_icon__12mIW","content":"SettlementRequirement_content__1iFc-"};